import {
    getTimezones,
    getWidgetPreview,
    updateWidget,
    getWidgetInfo,
    createWidget,
} from "../../api/api";

const state = {
    timers: [],
    timezones: [],
    languages: [
        { value: "ar-sa", text: "Arabic" },
        { value: "bg", text: "Bulgaria" },
        { value: "zh-cn", text: "Chinese (simplified)" },
        { value: "zh-tw", text: "Chinese (traditional)" },
        { value: "ca", text: "Catalan" },
        { value: "hr", text: "Croatian" },
        { value: "cs", text: "Czech" },
        { value: "da", text: "Danish" },
        { value: "nl", text: "Dutch" },
        { value: "en", text: "English" },
        { value: "et", text: "Estonian" },
        { value: "fa", text: "Farsi" },
        { value: "fi", text: "Finnish" },
        { value: "fr", text: "French" },
        { value: "geo", text: "Georgian" },
        { value: "de", text: "German" },
        { value: "el", text: "Greek" },
        { value: "he", text: "Hebrew" },
        { value: "hi", text: "Hindi" },
        { value: "hu", text: "Hungarian" },
        { value: "is", text: "Icelandic" },
        { value: "it", text: "Italian" },
        { value: "ja", text: "Japanese" },
        { value: "ko", text: "Korean" },
        { value: "lv", text: "Latvian" },
        { value: "lt", text: "Lithuanian" },
        { value: "no", text: "Norwegian" },
        { value: "pl", text: "Polish" },
        { value: "pt", text: "Portuguese" },
        { value: "ro", text: "Romanian" },
        { value: "ru", text: "Russian" },
        { value: "sk", text: "Slovak" },
        { value: "sl", text: "Slovenian" },
        { value: "es", text: "Spanish" },
        { value: "sv", text: "Swedish" },
        { value: "th", text: "Thai" },
        { value: "tr", text: "Turkish" },
        { value: "ua", text: "Ukrainian" },
        { value: "vi", text: "Vietnamese" },
    ],
    fontFamilies: [
        { value: "Agency FB", text: "Agency FB" },
        // { value: "Arial", text: "Arial" },
        // { value: "Arial Black", text: "Arial Black" },
        { value: "Arsenal", text: "Arsenal" },
        { value: "Comic Sans MS", text: "Comic Sans" },
        { value: "Courier New", text: "Courier New" },
        { value: "Curlz MT", text: "Curlz MT" },
        { value: "Georgia", text: "Georgia" },
        // { value: "Impact", text: "Impact" },
        { value: "Lucida Console", text: "Lucida Console" },
        { value: "Montserrat", text: "Montserrat" },
        // { value: "Open Sans", text: "Open Sans" },
        { value: "Palatino Linotype", text: "Palatino Linotype" },
        { value: "Playfair Display", text: "Playfair Display" },
        { value: "Playfair Display Black", text: "Playfair Display Black" },
        { value: "Quartz MS", text: "Quartz" },
        { value: "Roboto", text: "Roboto Regular" },
        { value: "Rubik", text: "Rubik" },
        { value: "Rubik Black", text: "Rubik Black" },
        { value: "Rubik Light", text: "Rubik Light" },
        { value: "Rubik Medium", text: "Rubik Medium" },
        { value: "Sanchez", text: "Sanchez" },
        { value: "MS Sans Serif", text: "Sans Serif" },
        { value: "Script MT Bold", text: "Script" },
        { value: "Stencil", text: "Stencil" },
        // { value: "MS Serif", text: "Serif" },
        { value: "Tahoma", text: "Tahoma" },
        { value: "Times New Roman", text: "Times" },
        { value: "Trebuchet MS", text: "Trebuchet" },
        { value: "Verdana", text: "Verdana" },
    ],
    colorSwatches: [
        {
            value: "#feb99a",
        },
        {
            value: "#f93f31",
        },
        {
            value: "#f7632b",
        },
        {
            value: "#fd6e60",
        },
        {
            value: "#f29983",
        },
        {
            value: "#fa99b9",
        },
        {
            value: "#dfaaab",
        },
        {
            value: "#cba86e",
        },
        {
            value: "#bb6452",
        },
        {
            value: "#f7d854",
        },
        {
            value: "#eece7c",
        },
        {
            value: "#f2b414",
        },
        {
            value: "#7c3d2a",
        },
        {
            value: "#d8855e",
        },
        {
            value: "#ff9e00",
        },
        {
            value: "#f45cc6",
        },
        {
            value: "#c50c8b",
        },
        {
            value: "#d0d45b",
        },
        {
            value: "#a489f5",
        },
        {
            value: "#ffaae5",
        },
        {
            value: "#fe97b7",
        },
        {
            value: "#2cd29b",
        },
        {
            value: "#49a77e",
        },
        {
            value: "#56b794",
        },
        {
            value: "#00594e",
        },
        {
            value: "#32887e",
        },
        {
            value: "#90dee5",
        },
        {
            value: "#b3c87c",
        },
        {
            value: "#bf96d9",
        },
        {
            value: "#c8b4e5",
        },
        {
            value: "#ccbac7",
        },
        {
            value: "#8599c5",
        },
        {
            value: "#92f1f4",
        },
        {
            value: "#89e7c2",
        },
        {
            value: "#e271ce",
        },
        {
            value: "#4950c0",
        },
        {
            value: "#689fcd",
        },
        {
            value: "#a3d5ff",
        },
        {
            value: "#2b63d2",
        },
        {
            value: "#5ad7a7",
        },
        {
            value: "#e499ef",
        },
        {
            value: "#008cd2",
        },
        {
            value: "#42a42e",
        },
        {
            value: "#54aea3",
        },
        {
            value: "#70b9d1",
        },
        {
            value: "#73bcf8",
        },
        {
            value: "#9fc0da",
        },
        {
            value: "#9cb8ff",
        },
        {
            value: "#2da0d1",
        },
        {
            value: "#ffffff",
        },
        {
            value: "#d7d7d7",
        },
        {
            value: "#b8b8b8",
        },
        {
            value: "#999999",
        },
        {
            value: "#797979",
        },
        {
            value: "#383838",
        },
        {
            value: "#000000",
        },
    ],
};

// getters
const getters = {
    timezones: state => {
        return state.timezones;
    },
    timers: state => state.timers,
    timerById: state => timerId => {
        return state.timers.find(timer => timer.widget.id === timerId);
    },
    languages: state => state.languages,
    colorSwatches: state => state.colorSwatches,
    fontFamilies: state => state.fontFamilies,
};

// actions
const actions = {
    getTimer({ }, { timerDetails, dashboardToken }) {
        return getWidgetPreview(timerDetails, dashboardToken).then(res => {
            return res;
        });
        // TimerSyle=1&EndDateTime=2020-12-08T00%3A59%3A00&EndTimeZoneInfo=Pacific%2BStandard%2BTime%3B-480%3B%28UTC-08%3A00%29%2BPacific%2BTime%2B%28US%2B%26%2BCanada%29%3BPacific%2BStandard%2BTime%3BPacific%2BDaylight%2BTime%3B%5B01%3A01%3A0001%3B12%3A31%3A2006%3B60%3B%5B0%3B02%3A00%3A00%3B4%3B1%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B10%3B5%3B0%3B%5D%3B%5D%5B01%3A01%3A2007%3B12%3A31%3A9999%3B60%3B%5B0%3B02%3A00%3A00%3B3%3B2%3B0%3B%5D%3B%5B0%3B02%3A00%3A00%3B11%3B1%3B0%3B%5D%3B%5D%3B&BackgroundColor=241.241.241&BackgroundTransparent=false&TextColor=153.153.153&BoxColor=0.0.0&FontFamily=Arial&FontSize=28&LanguageCode=en&ShouldUseDynamicLocal=false&IncludeDays=true
    },
    getTimezoneList({ commit }) {
        return getTimezones().then(result => {
            let timezones = result.data.timeZones.map(timezone => {
                return {
                    text: timezone.name,
                    value: timezone.value, // can also use id if we want to try the more simple version
                };
            });
            commit("setTimezones", timezones);
        });
    },
    getTimerPreview({ rootState }, widget) {
        const token = rootState.session.token;
        return getWidgetPreview(widget, token);
    },
    getTimerInfo({ commit, rootState }, widgetId) {
        const token = rootState.session.token;
        return getWidgetInfo({ widgetId: widgetId }, token).then(result => {
            commit("session/setToken", result.data.dashboardToken, {
                root: true,
            });
            // const newTimerData = { ...result.data.widgetDto };
            // delete the gif file info from the timer since it's not needed
            // delete newTimerData.gifFile;
            // update existing timer with this new data
            // commit("setTimer", newTimerData);
            return result.data.widgetDto;
        });
    },
    updateTimer({ commit, dispatch, rootState }, widget) {
        return dispatch("getTimerInfo", widget.id).then(() => {
            const token = rootState.session.token;
            return updateWidget(widget, token).then(result => {
                commit("session/setToken", result.data.dashboardToken, {
                    root: true,
                });
                commit("setTimer", result.data.widgetDto);
                return result.data.widgetDto;
            });
        });
    },
    // create a new timer by passing a widget object
    createTimer({ commit, rootState }, widget) {
        const token = rootState.session.token;
        return createWidget(widget, token).then(result => {
            commit("session/setToken", result.data.dashboardToken, {
                root: true,
            });
            commit("addTimer", result.data.widgetDto);
            return result.data.widgetDto;
        });
    },
};

// mutations
const mutations = {
    setTimezones(state, payload) {
        state.timezones = payload;
    },
    setTimers(state, payload) {
        state.timers = payload;
    },
    // sets an existing timer to new timer data passed in
    setTimer(state, payload) {
        const timerIndex = state.timers.findIndex(t => {
            return t.widget.id === payload.widget.id;
        });
        state.timers.splice(timerIndex, 1, payload);
    },
    // adds a timer object to the first position of the list
    addTimer(state, payload) {
        state.timers.splice(0, 0, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
